import { UserConfig } from "@ternary/api-lib/core/types";

const queryKeys = {
  all: ["scopedViews"] as const,
  user: (userConfig: UserConfig) => [...queryKeys.all, userConfig] as const,
};

export default queryKeys;
